<template lang="pug">
</template>

<script>
export default {
  mounted() {
    localStorage.removeItem("alert");
    this.$helpers.logout();
  }
};
</script>
